export default __webpack_public_path__ + "static/change-request-confirmation-9b3b14c636c54b14cda83f480fec2d9e.png";